import type { RemoteConfig, FeatureFlags } from '@funtech-int/yango-shared';
import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ProfileManager } from '@/shared/lib/profileManager';
import { Source } from '@/scenarios/legacy-player/types/config';

import { TelemetryContentPlace, TelemetryContentType } from '../../Player';
import { getOnlineStreamsConfig } from '../../feature-player/utils/config/get-online-streams-config';

import { getFilmOnlineStreams } from './get-film-online-streams';
import { getFilmPreferredTracks } from './get-film-preferred-tracks';
import { getFilmContentId } from './get-film-content-id';
import { getFilmStartPosition } from './get-film-start-position';

interface Dependencies {
    profileManager: ProfileManager;
    featureFlags: FeatureFlags;
    remoteConfig: RemoteConfig;
}

export const getFilmPlayerConfig: (
    filmOrVideo: LegacyFilmPlayerBaseInfoContent | LegacyVideoPlayerBaseInfoContent,
    deps: Dependencies
) => Source[] = (filmOrVideo, deps) =>
    getOnlineStreamsConfig(
        {
            contentId: getFilmContentId(filmOrVideo),
            preferredTracks: getFilmPreferredTracks(filmOrVideo),
            onlineStreams: getFilmOnlineStreams(filmOrVideo),
            startPosition: getFilmStartPosition(filmOrVideo),
            telemetry: {
                from_block: TelemetryContentPlace.Film,
                stream_block: TelemetryContentType.Film,
            },
        },
        deps
    );
